import BaseCheckbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./style.module.css";

export default class ToogleButtonField extends React.PureComponent {
  static propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.node,
  };

  onChange = ({ target: { checked } }) => this.props.onChange?.(checked);

  render() {
    const { value, className, onChange, label, disabled, icon, ...rest } = this.props;
    return (
      <FormControlLabel
        className={classnames(styles.container, className, {
          disabled,
          [styles.checked]: value,
        })}
        label={label}
        control={
          <BaseCheckbox onChange={this.onChange}
                        classes={{
                          root: styles.root,
                        }}
                        color="primary"
                        disableRipple
                        disableFocusRipple
                        disableTouchRipple
                        className='checkbox'
                        icon={<div className={styles.uncheckedIcon}>{icon}</div>}
                        checkedIcon={<div className={styles.checkedIcon}>{icon}</div>}
                        checked={value}
                        disabled={disabled}
                        {...rest}
          />}
      />
    );
  }
}
